import * as types from '../constants/action-types';
import { Messages } from '../../../../api/api-messages';
import Payments from '../../../../api/api-payments';

function messageCountRequest () {
  return {
    type: types.MESSAGE_COUNT_REQUEST
  };
}

export function messageCountSuccess (messageCount) {
  return {
    type: types.MESSAGE_COUNT_SUCCESS,
    messageCount
  };
}

function messageCountFailure () {
  return {
    type: types.MESSAGE_COUNT_FAILURE
  };
}

export function fetchMessageCount (accessToken, profile) {
  return dispatch => {
    const msgPath = `/v1/messages/user/threads/count?is_read=false&to=${profile.SSOid}`;

    dispatch(messageCountRequest());

    Messages.read(msgPath, accessToken, (response) => {
      if (response.error) {
        return dispatch(messageCountFailure());
      }

      const { thread_count } = response;
      return dispatch(messageCountSuccess(thread_count));
    });
  };
}

function managedAccountRequest () {
  return {
    type: types.MANAGED_ACCOUNT_REQUEST
  };
}

export function managedAccountSuccess (managedAccount) {
  return {
    type: types.MANAGED_ACCOUNT_SUCCESS,
    managedAccount
  };
}

function managedAccountFailure () {
  return {
    type: types.MANAGED_ACCOUNT_FAILURE
  };
}

export function fetchManagedAccount (accessToken, { SSOid }) {
  return dispatch => {
    dispatch(managedAccountRequest());

    Payments.getManagedAccountData(SSOid, accessToken, (response) => {
      if (response.error) {
        return dispatch(managedAccountFailure());
      }

      return dispatch(managedAccountSuccess(response));
    });
  };
}

function bankStatusRequest () {
  return {
    type: types.BANK_STATUS_REQUEST
  };
}

export function bankStatusSuccess (bankStatus) {
  return {
    type: types.BANK_STATUS_SUCCESS,
    bankStatus
  };
}

function bankStatusFailure () {
  return {
    type: types.BANK_STATUS_FAILURE
  };
}

export function fetchBankStatus (accessToken, { SSOid }) {
  return dispatch => {
    dispatch(bankStatusRequest());

    Payments.getBankStatusData(SSOid, accessToken, (response) => {
      if (response.error) {
        return dispatch(bankStatusFailure());
      }

      return dispatch(bankStatusSuccess(response));
    });
  };
}

export const setNavStep = (stepName, progressBarWidth) => {
  return {
    type: types.SET_NAV_STEP,
    stepName,
    progressBarWidth
  };
};

export const clearNavStep = () => {
  return {
    type: types.CLEAR_NAV_STEP
  };
};
